import { render } from "./User.vue?vue&type=template&id=6a070aea&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=6a070aea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a070aea"

export default script